<template>
  <div class="cartItem">
    <button type="button" class="btnDel" @click="delItem(itemList.orderId)"><span class="blind">delete</span></button>
    <p class="requestAt mb5 notranslate">
      <i class="orderId">{{locale.order_id}} {{itemList.orderId}}</i>
      <span class="paymentStatus">
        {{orderStatus}}
      </span>
    </p>
    <div class="inner">
      <div class="itemInner"
        v-for="(item, index) in items"
        :key="index">
        <PaymentItemAmenity
          v-if="item.submitId === 'system_amenity'"
          :itemData="item"
          :locale="locale"
          :lang="lang"
          :localeAmenity="localeAmenity" />
        <PaymentItem
          v-else
          :itemData="item"
          :locale="locale"
          :localeAmenity="localeAmenity"
          :lang="lang" />
      </div>
      <div v-if="paymentTotal" class="paymentBox">
        <div v-if="paymentTotal.tax || tip" class="taxPrice notranslate">
          <div v-if="paymentTotal.tax">
            <div class="payInfo">
              <span class="label">{{locale.subtotal}}</span>
              <span class="value">{{priceFormat(paymentTotal.subtotal)}}</span>
            </div>
            <div class="payInfo">
              <span class="label">{{locale.tax}}({{paymentTotal.taxLabel}})</span>
              <span class="value">{{priceFormat(paymentTotal.tax)}}</span>
            </div>
          </div>
          <div v-if="tip">
            <div class="payInfo">
              <div class="label">
                {{locale.tip}}({{tip.tipLabel}}<span v-if="tip.tipIncludeTax"> / {{locale.tip_include_tax}}</span>)
              </div>
              <span class="value">{{priceFormat(tip.total)}}</span>
            </div>
          </div>
        </div>
        <div class="payInfo notranslate">
          <span class="label">{{locale.payment_amount}}</span>
          <span class="value">{{priceFormat(paymentTotal.total)}}</span>
        </div>
      </div>
      <div class="notranslate">
        <router-link
          :to="{name: 'paymentReceipt', params: {orderId: itemList.orderId}}"
          class="btn btnRound sizeS btnWhite toCapitalize btnReceipt">
          {{isPaid ? locale.card_receipt : locale.card_receipt_refunded}}
        </router-link>
      </div>
      <!-- <div class="btns">
        <button type="button" class="btn sizeS btnFull btnWhite">{{locale.cancel}}</button>
      </div>
      <div class="status toUppercase">
        <div class="item on active"><span class="label">ready</span></div>
        <div class="item"><span class="label">progress</span></div>
        <div class="item"><span class="label">complete</span></div>
        <div class="item"><span class="label">cancel</span></div>
      </div> -->
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import { DateTime } from 'luxon'
import PaymentItem from '@/components/Mypage/PaymentItem'
import PaymentItemAmenity from '@/components/Mypage/PaymentItemAmenity'

export default {
  name: 'PaymentListItem',
  props: [
    'itemList',
    'lang',
    'locale'
  ],
  components: {
    PaymentItem,
    PaymentItemAmenity
  },
  computed: {
    localeAmenity () {
      return this.$store.state.system.localeAmenity.data
    },
    items () {
      const items = this.itemList.payload.payload
      const list = Array.isArray(items) ? items : [items]
      return list.filter(x => x.submitId !== 'tip')
    },
    isPaid () {
      return this.itemList.orderStatus === 'paid'
    },
    orderStatus () {
      const isPaid = this.isPaid
      const datetime = this.datetimeFormat(this.itemList.updateat)
      const status = isPaid ? this.locale.order_status_paid : this.locale.order_status_refunded
      return `${status} (${datetime})`
    },
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    format () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      const time = 'HH:mm:ss'
      return `${date} ${time}`
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    paymentAmount () {
      const prices = this.items.map(x => x.price.info.total || 0)
      const sum = (a, b) => a + b
      return prices.reduce(sum)
      // return prices
    },
    tip () {
      const items = this.itemList.payload.payload
      const list = Array.isArray(items) ? items : [items]
      const tip = list.find(x => x.submitId === 'tip')
      return tip ? tip.price.info : null
    },
    paymentTotal () {
      const hasPrice = this.items.filter(x => x.price && x.price.info).length > 0
      const prices = hasPrice ? this.items.filter(x => x.price && x.price.info).map(x => x.price.info) : null
      const tax = prices ? prices.map(x => x.tax) : null
      const taxLabel = prices && tax ? prices[0].subtotal / prices[0].tax : null
      const subtotal = prices ? prices.map(x => x.subtotal) : null
      const total = prices ? prices.map(x => x.total) : null
      const tip = this.tip ? this.tip.total : 0
      const sum = (a, b) => a + b
      return prices
        ? {
          ...tax.length > 0 && { tax: tax.reduce(sum), taxLabel: `${taxLabel}%` },
          ...subtotal.length > 0 && { subtotal: subtotal.reduce(sum) },
          total: total.reduce(sum) + tip
        } : null
    }
  },
  data () {
    return {
      paymentReceipt: false,
      receiptData: null
    }
  },
  methods: {
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(price, code)
    },
    datetimeFormat (iso) {
      const datetime = DateTime.fromISO(iso, { zone: this.timezone })
      return datetime.toFormat(this.format)
    },
    delItem (orderId) {
      if (window.confirm(this.locale.confirm_order_delete)) {
        this.$emit('deleteItem', orderId)
      }
    },
    setReceipt (orderId) {
      this.paymentReceipt = !this.paymentReceipt
      if (orderId) {
        this.$store.dispatch('payment/getReceipt', orderId).then((res) => {
          const payload = Array.isArray(res.payload) ? res.payload : new Array(res.payload)
          // 결제정보
          const paymentInfo = {
            cardName: res.cardName || '-', // 카드종류
            cardNumber: res.cardNumber || '-', // 카드번호
            payMethod: res.payMethod || '-', // 거래종류
            authDate: res.authDate || '-', // 거래일시
            cardQuota: res.cardQuota || 0, // 할부개월
            authCode: res.authCode || '-',
            type: res.type, // 거래유형
            refundDate: res.refundDate // 취소일시
          }
          // 구매정보
          const goodsInfo = {
            orderId: orderId, // 주문번호
            details: payload,
            amt: res.amt
          }
          const shopInfo = {
            shopName: res.shopName || '-', // 상호명
            shopBizNumber: res.shopBizNumber || '-', // 사업자등록번호
            shopAddress: res.shopAddress || '-' // 주소
          }
          // 이용상점 정보
          this.receiptData = {
            paymentInfo: paymentInfo,
            goodsInfo: goodsInfo,
            shopInfo: shopInfo
          }
        })
      } else {
        this.receiptData = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.orderList .cartItem .btnReceipt {
  padding-left: 0.5em;
  padding-right: 0.5em;
  text-align: left;
  font-size: 0.75em;
}
</style>
